/* eslint-disable no-restricted-globals */
import axios from 'axios';
import https from 'https';

const apiAssist = axios.create({
  baseURL: `/chamados`,
  httpsAgent: new https.Agent({
    rejectUnauthorized: true,
  }),
});

export default apiAssist;
